import { TableControlPanel } from './TableControlPanel';

export default TableControlPanel;
